/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["24.00", "12.00", "zj", "d", "p", "zv", "po"], ["opoln.", "opold.", "zjut.", "dop.", "pop.", "zveč.", "ponoči"], ["opolnoči", "opoldne", "zjutraj", "dopoldan", "popoldan", "zvečer", "ponoči"]], [["24.00", "12.00", "j", "d", "p", "v", "n"], ["poln.", "pold.", "jut.", "dop.", "pop.", "zveč.", "noč"], ["polnoč", "poldne", "jutro", "dopoldne", "popoldne", "večer", "noč"]], ["00:00", "12:00", ["06:00", "10:00"], ["10:00", "12:00"], ["12:00", "18:00"], ["18:00", "22:00"], ["22:00", "06:00"]]];
